import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { BasicModal, DefaultButton } from 'common/components';
import Arrow from 'common/components/tables/CustomTable/icons/Arrow';
import ChangePaymentStatusForm from '../ChangePaymentStatusForm';
import ChangeStatusButtonWarning from '../ChangeStatusButtonWarning';
import { staticStyles } from './style';
import { getTransfersStatuses } from '../../../transfers/_redux';

const ChangeStatusButton = ({
  depositStatuses,
  withdrawalStatuses,
  transfersStatuses,
  requestId,
  type,
  getTransfersStatuses,
}) => {
  const [isChangeStatusOpen, setChangeStatusOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const paymentStatusesMap = {
    deposits: 'deposit',
    withdrawals: 'withdraw',
    transfer: 'transfer',
  };

  const optionsStatusesMap = {
    deposits: depositStatuses,
    withdrawals: withdrawalStatuses,
    transfer: transfersStatuses,
  };

  const toggleChangeStatusForm = () => {
    setChangeStatusOpen(open => !open);
  };

  const handleCollapse = () => {
    setIsCollapsed(isCollapsed => !isCollapsed);
  };

  useEffect(() => {
    getTransfersStatuses();
  }, [getTransfersStatuses]);

  return (
    <div>
      <button type="button" className="ChangeStatusButton" onClick={handleCollapse}>
        <FormattedMessage id="boChangeStatus">
          {txt => <span className="ChangeStatusButton__caption">{txt}</span>}
        </FormattedMessage>
        <div
          className={classNames('ChangeStatusButton__icon-wrapper', {
            'ChangeStatusButton__icon-wrapper-collapsed': isCollapsed,
          })}>
          <Arrow />
        </div>
      </button>
      {isCollapsed && (
        <>
          <ChangeStatusButtonWarning />
          <DefaultButton
            className="ChangeStatusButton__button"
            textId="boChangeStatus"
            butColor="warning"
            onClick={toggleChangeStatusForm}
          />
        </>
      )}
      <BasicModal
        modalClassName="ChangePaymentStatusModal"
        isOpen={isChangeStatusOpen}
        captionId="boChangeStatus"
        onRequestClose={toggleChangeStatusForm}>
        <ChangePaymentStatusForm
          statuses={optionsStatusesMap[type] || []}
          requestId={requestId}
          type={paymentStatusesMap[type]}
          closeModal={toggleChangeStatusForm}
        />
      </BasicModal>
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

ChangeStatusButton.propTypes = {
  requestId: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  withdrawalStatuses: PropTypes.array,
  depositStatuses: PropTypes.array,
  transfersStatuses: PropTypes.array,
  getTransfersStatuses: PropTypes.func.isRequired,
};

ChangeStatusButton.defaultProps = {
  withdrawalStatuses: [],
  depositStatuses: [],
  transfersStatuses: [],
};

export default compose(
  connect(
    state => ({
      withdrawalStatuses: state.backoffice.payments.withdrawalStatuses,
      depositStatuses: state.backoffice.payments.depositStatuses,
      transfersStatuses: state.backoffice.transfers.transfersStatuses,
    }),
    { getTransfersStatuses: () => getTransfersStatuses.request() }
  )
)(ChangeStatusButton);
export { ChangeStatusButton };
